import { COHORT_MIN_SIZE, COHORT_MONTHS, share } from '../../../core/rules/insights/stats';
import { monthShort } from '../../../core/format/dates';
import type { CustomerInsights } from '../../../core/types/insights';
const shade = (pct: number) => pct >= 60 ? 'bg-sage/45' : pct >= 40 ? 'bg-sage/30' : pct >= 20 ? 'bg-sage/15' : 'bg-sage/5';

/**
 * Cohorten: van wie in een maand begon, hoeveel kwam terug na 1, 3 en 6 maanden. Een venster
 * dat nog niet om is: "–". Een kleine groep: het aantal in grijs, geen percentage.
 */
export function CohortTable({
  cohorts
}: {
  cohorts: CustomerInsights['cohorts'];
}) {
  if (cohorts.length === 0) return <p className="text-[13px] text-muted" data-id="element-2042" data-mp="gv3bstjqup8t">Nog geen klanten om te volgen.</p>;
  return <div className="-mx-4 overflow-x-auto sm:mx-0" data-id="element-2043" data-mp="kulmyxlrjlyg">
      <table className="w-full min-w-max text-[13px]" data-id="element-2044" data-mp="kx6ofli5fzvo">
        <caption className="sr-only" data-id="element-2045" data-mp="2b8uf7bbhccvt">Terugkeer per startmaand</caption>
        <thead className="text-[12px] text-muted" data-id="element-2046" data-mp="2f9wj45gcdd44">
          <tr className="border-b border-line" data-id="element-2047" data-mp="2f8lek3f2o1by">
            <th scope="col" className="py-2 pl-4 pr-3 text-left font-normal sm:pl-0" data-id="element-2048" data-mp="2ivw6dadr1621">
              Begonnen
            </th>
            <th scope="col" className="px-3 py-2 text-right font-normal" data-id="element-2049" data-mp="2dwjluwacob2m">
              Klanten
            </th>
            {COHORT_MONTHS.map(m => <th key={m} scope="col" className="px-1 py-2 text-center font-normal last:pr-4 sm:last:pr-0" data-id="element-2050" data-mp="2nn4fs6f2wrf7">
                Na {m} {m === 1 ? 'maand' : 'maanden'}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-2051" data-mp="1uz8o5g4d9ppa">
          {cohorts.map(c => <tr key={c.month} data-id="element-2052" data-mp="1v0jt3j9jt3hz">
              <th scope="row" className="py-1 pl-4 pr-3 text-left font-normal capitalize text-ink sm:pl-0" data-id="element-2053" data-mp="29vg3o34ty2y8">
                {monthShort(c.month)}
              </th>
              <td className="px-3 py-1 text-right tabular-nums text-muted" data-id="element-2054" data-mp="24yptfwfpi1kq">{c.size}</td>
              {c.returned.map((n, i) => {
            const pct = n === null ? null : share(n, c.size, COHORT_MIN_SIZE);
            return <td key={i} className="px-1 py-1 last:pr-4 sm:last:pr-0" data-id="element-2055" data-mp="3nfhynzp967bg" data-mpi={i}>
                    <span className={`flex h-8 min-w-[5.5rem] items-center justify-center rounded tabular-nums ${n === null ? 'text-muted' : pct === null ? 'bg-sand text-muted' : `${shade(pct)} text-ink`}`} data-id="element-2056" data-mp="3se2xpvsrqkyb">
                      {n === null ? '–' : pct === null ? `${n} van ${c.size}` : `${pct}%`}
                    </span>
                  </td>;
          })}
            </tr>)}
        </tbody>
      </table>
    </div>;
}